module.exports = __webpack_public_path__ + "media/images/ministere-ee14866d3949ba64355622a21787f86e.png";